import axios from 'axios';
import store from '../store'
import router from '../router'

const API_KEY = process.env.VUE_APP_API_KEY;
const api = axios.create({
    baseURL: `${process.env.VUE_APP_URL_API}`,
    headers: {
        'x-api-key': API_KEY,
        'Content-Type': 'application/json',
    },
});

api.interceptors.request.use(
    (config) => {
        const user = JSON.parse(localStorage.getItem('userData'));

        if (user && user.token) {
            config.headers['Authorization'] = `Bearer ${user.token}`;
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// INTERCEPTOR DE RESPONSE (O QUE FALTAVA!)
api.interceptors.response.use(
    response => response,
    error => {
        const status = error.response?.status;

        if (status === 401) {
            store.commit('setToken', null);
            localStorage.removeItem('userData');

            router.push('/');
        }

        return Promise.reject(error);
    }
);

export default api;